import { useRouteError } from "react-router-dom";
import Page from "../components/page/Page";
import { Button, Box, Typography } from '@mui/material';
import EnvironmentVariables from "../shared/environmentVariables";
import { useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError() as any;
  const navigate = useNavigate();

  return (
    <Page>
      <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Box sx={{ '& button': { m: 1 }, display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 1, textAlign: 'center' }}>
          <Typography variant="h3" textAlign="center">We're Sorry</Typography>
          <p>
            An unexpected error has occurred. 
          </p>
          {EnvironmentVariables.ENVIRONMENT !== "Production" && 
            <Box marginBottom={2}>
              <Typography><i>{error.statusText || error.message}</i></Typography>
            </Box>
          }
          <Box width='sm'>
            <Button variant='contained' size='medium' onClick={() => { navigate('/') }}>Return Home</Button>
          </Box>
        </Box>
      </Box>
    </Page>
  );
}